import { Component, ViewEncapsulation } from '@angular/core';
import { CoreServices, FlexusAppBase } from 'flx-engine';
import { ActivatedRoute } from '@angular/router';
import {Router} from '@angular/router';


@Component({
    selector: 'workflow-app',
    template: `
       <main>
            <section
                class="app-shell-container action-panel-visible"
                #appShell
                [ngClass]="[expandActionPanel ? 'action-panel-expand' : 'action-panel-collapse']"
            >
                <section class="module-wrapper">
                <flx-app-bar></flx-app-bar>
                <section class="module-container">
                    <router-outlet></router-outlet>
                </section>
                <app-footer></app-footer>
                </section>
            </section>
            <ng-container>
            <div class="action-panel-container">
                <aside
                    class="action-panel action-panel__padding"
                    #actionPanel
                    [ngClass]="{
                    'action-panel-expand': expandActionPanel,
                    'action-panel-closed': !expandActionPanel}"
                >
                    <router-outlet *ngIf="expandActionPanel" name="actionPanel"></router-outlet>
                </aside>
                <nav class="action-panel-navigation">
                    <div class="top-icons">
                    <div class="avatar-container">
                        <div class="avatar">HJ</div>
                    </div>
                    <a *ngFor="let action of panelActions$ | async"
                    [routerLink]="[{ outlets: { actionPanel: clickedActionPanel } }]"
                    [queryParams]="{ expandActionPanel: expandActionPanel}" queryParamsHandling="merge">
                        <flx-icon
                            [type]="action.icon"
                            [isActive]="clickedActionPanel === action.path ? true : false"
                            active="primary"
                            class="action-panel-button"
                            use="action-panel"
                            hover="primary"
                            [instruction]="action.instruction"
                            (click)="clickPanel(action.path)"
                        >
                            {{ action.icon }}
                        </flx-icon>
                    </a>
                    </div>
                    <div class="bottom-icons">
                        <!-- -->
                    </div>
                </nav>
                </div>

            </ng-container>
        </main>
    `,
    encapsulation: ViewEncapsulation.None,
    styleUrls: ['workflow-app.component.scss']
})
export class WorkflowAppComponent extends FlexusAppBase {

    constructor(svc: CoreServices, route: ActivatedRoute, router: Router) {
        super(svc, route, router);
    }
}
